/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * CRUD permission matrix
 * @export
 * @interface DatabaseEntryPermission
 */
export interface DatabaseEntryPermission {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryPermission
     */
    create?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryPermission
     */
    readOwnedEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryPermission
     */
    readForeignEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryPermission
     */
    readAllEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryPermission
     */
    updateOwnedEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryPermission
     */
    updateForeignEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryPermission
     */
    deleteOwnedEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryPermission
     */
    deleteForeignEntries?: boolean;
}

/**
 * Check if a given object implements the DatabaseEntryPermission interface.
 */
export function instanceOfDatabaseEntryPermission(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEntryPermissionFromJSON(json: any): DatabaseEntryPermission {
    return DatabaseEntryPermissionFromJSONTyped(json, false);
}

export function DatabaseEntryPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntryPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'create': !exists(json, 'create') ? undefined : json['create'],
        'readOwnedEntries': !exists(json, 'readOwnedEntries') ? undefined : json['readOwnedEntries'],
        'readForeignEntries': !exists(json, 'readForeignEntries') ? undefined : json['readForeignEntries'],
        'readAllEntries': !exists(json, 'readAllEntries') ? undefined : json['readAllEntries'],
        'updateOwnedEntries': !exists(json, 'updateOwnedEntries') ? undefined : json['updateOwnedEntries'],
        'updateForeignEntries': !exists(json, 'updateForeignEntries') ? undefined : json['updateForeignEntries'],
        'deleteOwnedEntries': !exists(json, 'deleteOwnedEntries') ? undefined : json['deleteOwnedEntries'],
        'deleteForeignEntries': !exists(json, 'deleteForeignEntries') ? undefined : json['deleteForeignEntries'],
    };
}

export function DatabaseEntryPermissionToJSON(value?: DatabaseEntryPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'create': value.create,
        'readOwnedEntries': value.readOwnedEntries,
        'readForeignEntries': value.readForeignEntries,
        'readAllEntries': value.readAllEntries,
        'updateOwnedEntries': value.updateOwnedEntries,
        'updateForeignEntries': value.updateForeignEntries,
        'deleteOwnedEntries': value.deleteOwnedEntries,
        'deleteForeignEntries': value.deleteForeignEntries,
    };
}

